import React from 'react'
import getBookingFormattedDate from '../../Config/Booking'

export const NotificationInfo = (props:any) => {
  return (

    <div className="outer-container">
   
    {props.schedule_date ?<div className="inner-container">
      <div className="info-container">
        <span className="tooltext">{`Scheduled At :${getBookingFormattedDate(props.schedule_date)}- ${props.schedule_time}`}</span>
      </div>
    </div> : 
    <div>
        No information found
    </div>
    }
    {props.trigger_date && <div className="inner-container">
      <div className="info-container">
      {/* <span className="tooltext">Triggered At :</span> */}
        <span className="tooltext">{`Triggered At : ${getBookingFormattedDate(props.trigger_date)}- ${props.trigger_time}`}</span>
      </div>
    </div>}
  </div>
  )
}
